module.exports = __webpack_public_path__ + "static/media/bn.4f010489.svg";